<template lang="html">
  <div id="reschedulingSenderCompletion">
    <section class="section">
      <h1 class="section-description">授業振替依頼が完了しました</h1>
      <h1 class="section-description">依頼が承認または不承認されたらメールが届きますのでしばらくお待ちください</h1>
    </section>
    <router-link tag="button" to="/SpTable" title="座席予約表に戻る" class="menubutton">
      <span>座席予約表に戻る</span>
    </router-link>
  </div>
</template>
<script>
  export default {
    data () {
      return {}
    }
  }
</script>
<style lang="css" scoped>
  .section {
    border-bottom: solid 2px black;
    text-align: center;
    margin: 10px 5% 10px 5%;
    padding-bottom: 20px;
  }
  .section-description {
    font-size: 18px;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// SpSenderCompletion.vue?20110e84